import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCross: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medical-cross, first-aid, emergency"><path d="M14.25 2C15.2165 2 16 2.7835 16 3.75V7.75C16 7.88807 16.1119 8 16.25 8H20.25C21.2165 8 22 8.7835 22 9.75V14.25C22 15.2165 21.2165 16 20.25 16H16.25C16.1119 16 16 16.1119 16 16.25V20.25C16 21.2165 15.2165 22 14.25 22H9.75C8.7835 22 8 21.2165 8 20.25V16.25C8 16.1119 7.88807 16 7.75 16H3.75C2.7835 16 2 15.2165 2 14.25V9.75C2 8.7835 2.7835 8 3.75 8H7.75C7.88807 8 8 7.88807 8 7.75V3.75C8 2.7835 8.7835 2 9.75 2H14.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMedicalCross;
